import React from "react";

const PricingCard = ({ mediaKitAmount, taxAmount }) => {
  return (
    <>
      <div className="w-full my-8 overflow-hidden border border-black rounded bg-secondary-gorgias/60">
        <div className="p-3 px-5 border-b center font-outfit">
          <span className="text-left w-[60%] flex-1 text-sm tracking-[6%]">Professional Media Kit</span>
          <span className="mx-2 text-neutral">:</span>
          <span className="text-right w-[30%] text-sm tracking-[6%]">
            <sup>$</sup>
            {mediaKitAmount}
            <span className="text-neutral-dark1">/mo.</span>
          </span>
        </div>
        <div className="p-3 px-5 border-b border-black center font-outfit">
          <span className="flex-1 text-left text-sm tracking-[6%]">Tax</span>
          <span className="mx-2 text-neutral">:</span>
          <span className="text-right w-[30%] text-sm tracking-[6%]">
            {taxAmount ? (
              <span className="w-[30%]">
                <sup>$</sup>
                {taxAmount}
              </span>
            ) : (
              ""
            )}
            <span className="text-neutral-dark1">
              {taxAmount ? "/mo." : "--"}
            </span>
          </span>
        </div>
        <div className="p-3 px-5 bg-white center font-outfit">
          <span className="flex-1 font-medium text-left text-sm tracking-[6%]">TOTAL</span>
          <span className="mx-2 text-neutral"> :</span>
          <span className="text-right w-[30%] text-base tracking-[6%]">
            <sup>$</sup>
            {mediaKitAmount + (taxAmount || 0)}
            <span className="text-neutral-dark1">/mo.</span>
          </span>
        </div>
      </div>
    </>
  );
};

export default PricingCard;
